const PropertyOverview = ({ property }) => {
  const description = property?.description;
  const highlights = property?.highlights || [];

  if (!description && !highlights.length) {
    return (
      <section className="property-detail-section" aria-label="Property overview">
        <h2 className="property-detail-section__title">Overview</h2>
        <p className="property-detail-empty">
          No public description is available for this listing yet.
        </p>
      </section>
    );
  }

  return (
    <section className="property-detail-section" aria-label="Property overview">
      <h2 className="property-detail-section__title">Overview</h2>
      {description ? (
        <div className="property-detail-overview__description">{description}</div>
      ) : null}
      {highlights.length ? (
        <ul className="property-detail-overview__highlights">
          {highlights.map((item) => (
            <li key={item}>{item}</li>
          ))}
        </ul>
      ) : null}
    </section>
  );
};

export default PropertyOverview;
